import { useEffect } from 'react';

const usePreventKeyboardScrolling = (active: boolean) => {
  const onKeyDown = (e: KeyboardEvent) => {
    if (['ArrowUp', 'ArrowDown'].includes(e.code)) {
      e.preventDefault();
    }
  };

  useEffect(() => {
    if (active) {
      window.addEventListener('keydown', onKeyDown, false);
    }
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [active]);
};

export default usePreventKeyboardScrolling;
